import React from 'react';
import { TableCell, Typography, Box } from '@mui/material';
import { formatValueWithResolution, formatDisplayValue } from './utils';

type CalculatedValueCellProps = {
  value: number | null;
  tolerance: number;
  resolution?: number;
  section?: 'asFound' | 'asLeft';
};

export const CalculatedValueCell: React.FC<CalculatedValueCellProps> = ({
  value,
  tolerance,
  resolution,
  section
}) => {
  const exceedsTolerance = value !== null && Math.abs(value) > tolerance;

  const getCellBackground = () => {
    if (section === 'asFound') {
      return { backgroundColor: 'rgba(33, 150, 243, 0.02)' };
    }
    if (section === 'asLeft') {
      return { backgroundColor: 'rgba(76, 175, 80, 0.02)' };
    }
    return {};
  };

  return (
    <TableCell sx={{ ...getCellBackground(), textAlign: 'center' }}>
      <Box
        sx={{
          border: exceedsTolerance ? 2 : 0,
          borderColor: 'error.main',
          borderRadius: 1,
          padding: exceedsTolerance ? 0.5 : 0,
          display: 'inline-block'
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: exceedsTolerance ? 'error.main' : 'inherit',
            fontWeight: exceedsTolerance ? 600 : 400
          }}
        >
          {value !== null
            ? resolution !== undefined
              ? formatValueWithResolution(value, resolution)
              : formatDisplayValue(value)
            : '--'}
        </Typography>
      </Box>
    </TableCell>
  );
};
